import React from 'react';
import Button from './Button';

const Pagination = ({
  items,
  itemsPerPage,
  currentPage,
  onPageChange,
  renderItems,
  className = '',
}) => {
  const totalPages = Math.ceil(items.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <div className="w-full">{renderItems(currentItems)}</div>
      <div className="flex justify-center items-center mt-6 space-x-4">
        <Button
          label="Previous"
          onClick={() => onPageChange(currentPage - 1)}
          variant="secondary"
          disabled={currentPage === 1}
        />
        <span className="text-lg font-semibold text-gray-800">
          Page {currentPage} of {totalPages}
        </span>
        <Button
          label="Next"
          onClick={() => onPageChange(currentPage + 1)}
          variant="secondary"
          disabled={currentPage === totalPages}
        />
      </div>
    </div>
  );
};

export default Pagination;
